//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import creditCardType from 'credit-card-type';

export default {
    props: ['inresident', 'isapplicant'],
    data: function data() {
        return {
            resident: this.inresident,
            ccCardNumber: null,
            ccCardExpMonth: null,
            ccCardExpYear: null,
            ccCardCVC: null,
            ccCardHolder: this.inresident.person ? this.inresident.person.first_name + ' ' + this.inresident.person.last_name : null,
            ccBillingAddress: '',
            ccBillingCity: '',
            ccBillingState: '',
            paymentType: '',
            ccBillingZip: '',
            selectedCCType: '',
            amount: 0,
            loading: false,
            error: null,
            success: false,
            isApplicant: this.isapplicant || false
        };
    },

    watch: {
        inresident: function inresident(newData, oldData) {

            this.resident = newData;
            this.ccCardHolder = this.inresident.person.first_name + ' ' + this.inresident.person.last_name;
        }
    },
    created: function created() {
        Event.$on('resident-add-payment', this.residentAddPayment);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('resident-add-payment');
    },
    mounted: function mounted() {},

    methods: {
        residentAddPayment: function residentAddPayment() {

            var $el = this;

            $el.$children[0].$data.showSmallModal = true;
            $el.ccCardNumber = null;
            $el.ccCardExpMonth = null;
            $el.ccCardExpYear = null;
            $el.ccCardCVC = null;
            $el.ccBillingAddress = '';
            $el.ccBillingCity = '';
            $el.ccBillingState = '';
            $el.paymentType = '';
            $el.ccBillingZip = '';
            $el.selectedCCType = '';
            $el.amount = 0;
            $el.loading = false;
            $el.error = null;
            $el.success = false;
        },
        submitPayment: function submitPayment() {
            var _this = this;

            var self = this;
            this.loading = true;
            this.error = null;

            var sendData = {
                type: this.isApplicant ? 'applicant' : 'resident',
                person_id: this.resident.id,
                expiration_month: this.ccCardExpMonth,
                expiration_year: this.ccCardExpYear,
                card_number: this.ccCardNumber,
                cvc: this.ccCardCVC,
                card_holder: this.ccCardHolder,
                cc_type: this.selectedCCType,
                zip: this.ccBillingZip,
                address: this.ccBillingAddress,
                amount: this.amount
            };

            window.axios.post('/prototype/payment', sendData).then(function (response) {
                console.log('response', response.data);
                if (response.data) {
                    if (_this.isApplicant) {
                        Event.$emit('mark-application-paid');
                    }
                }

                self.loading = false;
                self.success = true;
            }).catch(function (error) {
                self.loading = false;
                self.success = false;
                self.error = "There was an error:";

                var errors = error.response.data.errors;

                for (var e in errors) {
                    if (errors.hasOwnProperty(e)) {
                        self.error += "\n" + errors[e][0];
                    }
                }
            });
        }
    },
    computed: {
        ccType: function ccType() {

            var n = creditCardType(this.ccCardNumber);

            if (n.length && n.length == 1) {

                this.selectedCCType = n[0].niceType;

                return n[0].niceType;
            }

            return '...';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentAddPayment.vue
// module id = Iqjw
// module chunks = 0 1